import React, {
    useContext,
    useEffect,
    useState
}
from "react";

import { useHistory }
from "react-router-dom";

import { store }
from "../../../context/store";

import { functions }
from "../../../constants/common-functions";

import {
    COLOR_FOCUS,
    COLOR_EDIT,
    COLOR_MEETING,
    COLOR_ALTERNATIVE,
    COLOR_SOCIAL
}
from "../../../constants/general-constants";

import MobileUtilisationCard
from "./components/MobileUtilisationCard";

import "./MobileHomeUtilisation.css";

import MobileHeader
from "./components/MobileHeader";

import MobileUtilisationNavigator
from "../../utilisation/mobile/components/MobileUtilisationNavigator";


export default function MobileHomeUtilisation()
{

    //--------------------------------------------------------
    // Context
    //--------------------------------------------------------

    const globalState =
        useContext(store);

    const history =
        useHistory();

    const queryContext =
        globalState?.state?.queryContext;


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [cards, setCards] =
        useState([]);
		
		const [showMenu, setShowMenu] =
			    useState(false);


    //--------------------------------------------------------
    // Load
    //--------------------------------------------------------

    useEffect(
        () =>
        {
            loadDashboard();
        },
        [
            queryContext?.utilisationSurveyId
        ]
    );


    //--------------------------------------------------------
    // Dashboard
    //--------------------------------------------------------

    const loadDashboard =
        () =>
        {

            const filterBean = {};

            functions.postFilterBeanAjax(

                "/resolutionsoftwareplatform/utilisationsummary/published",

                functions.buildPostBodyFilterBeanQueryContext(
                    filterBean,
                    queryContext
                ),

                handleUtilisationHomeComponent

            );

        };


    //--------------------------------------------------------
    // Response
    //--------------------------------------------------------

    const handleUtilisationHomeComponent =
        (obj) =>
        {

            console.log(
                "MOBILE UTILISATION",
                obj
            );


            const workstations =
                obj.dashboardHomeUtilisationGroupWorkstations || {};

            const observations =
                obj.dashboardHomeUtilisationGroupObservations || {};

            const average =
                obj.dashboardHomeUtilisationGroupAverage || {};

            const peak =
                obj.dashboardHomeUtilisationGroupPeak || {};


            //------------------------------------------------
            // Helper
            //------------------------------------------------

            const number =
                (value, decimals = 0) =>
                {

                    if(
                        value === null
                        ||
                        value === undefined
                    )
                    {
                        return "—";
                    }

                    return functions.formatNumber(
                        value,
                        decimals
                    );

                };


            const percentage =
                (value) =>
                {

                    if(
                        value === null
                        ||
                        value === undefined
                    )
                    {
                        return "—";
                    }

                    return (
                        functions.formatNumber(
                            value,
                            1
                        )
                        +
                        "%"
                    );

                };


            //------------------------------------------------
            // Cards
            //------------------------------------------------

            setCards(
                [

                    {
                        id: 1,
                        title: "Focus Worksettings",
                        icon: "desktop",
                        color: COLOR_FOCUS,

                        worksettings:
                            number(
                                workstations.focus
                            ),

                        observations:
                            number(
                                observations.focus
                            ),

                        average:
                            percentage(
                                average.focus
                            ),

                        peak:
                            percentage(
                                peak.focus
                            ),

                        clickFunction:
                            () =>
                            {
                                history.push(
                                    "/utilisationall/-100/1"
                                );
                            }
                    },


                    {
                        id: 2,
                        title: "Technical Spaces",
                        icon: "film",
                        color: COLOR_EDIT,

                        worksettings:
                            number(
                                workstations.edit
                            ),

                        observations:
                            number(
                                observations.edit
                            ),

                        average:
                            percentage(
                                obj.technicalAverage
                            ),

                        peak:
                            percentage(
                                peak.edit
                            ),

                        clickFunction:
                            () =>
                            {
                                history.push(
                                    "/utilisationallmeeting/-100/5"
                                );
                            }
                    },


                    {
                        id: 3,
                        title: "Meeting Rooms",
                        icon: "users",
                        color: COLOR_MEETING,

                        worksettings:
                            number(
                                workstations.meeting
                            ),

                        observations:
                            number(
                                observations.meeting
                            ),

                        average:
                            percentage(
                                obj.meetingAverage
                            ),

                        peak:
                            percentage(
                                peak.meeting
                            ),

                        clickFunction:
                            () =>
                            {
                                history.push(
                                    "/utilisationallmeeting/-100/3"
                                );
                            }
                    },


                    {
                        id: 4,
                        title: "Alternative Worksettings",
                        icon: "couch",
                        color: COLOR_ALTERNATIVE,

                        worksettings:
                            number(
                                workstations.alternative
                            ),

                        observations:
                            number(
                                observations.alternative
                            ),

                        average:
                            percentage(
                                obj.alternativeAverage
                            ),

                        peak:
                            percentage(
                                peak.alternative
                            ),

                        clickFunction:
                            () =>
                            {
                                history.push(
                                    "/utilisationallmeeting/-100/4"
                                );
                            }
                    },


                    {
                        id: 5,
                        title: "Social Space",
                        icon: "utensils",
                        color: COLOR_SOCIAL,

                        worksettings:
                            number(
                                workstations.social
                            ),

                        observations:
                            number(
                                observations.social
                            ),

                        average:
                            percentage(
                                obj.socialAverage
                            ),

                        peak:
                            percentage(
                                peak.social
                            ),

                        clickFunction:
                            () =>
                            {
                                history.push(
                                    "/utilisationallmeeting/-100/2"
                                );
                            }
                    }

                ]
            );

        };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (
		<div
				    style={{
				        display:"flex",
				        flexDirection:"column",
				        width:"100%",
				        height:"100vh",
				        overflow:"hidden"
				    }}
				>
		<MobileHeader
           openMenu={
               () => setShowMenu(true)
           }
           openSearch={
               () => console.log("SEARCH")
           }
       />
        <div className="mobile-utilisation">
		

            {/*-----------------------------------------------
                Introduction
            -----------------------------------------------*/}

            <div className="mobile-utilisation-heading">

                <div className="mobile-utilisation-title">
                    Utilisation Summary
                </div>

                <div className="mobile-utilisation-subtitle">

                    Average and peak day analysis across all
                    worksettings, highlighting overall demand,
                    pressure points and utilisation efficiency.

                </div>

            </div>


            {/*-----------------------------------------------
                Cards
            -----------------------------------------------*/}

            <div className="mobile-utilisation-card-list">

                {
                    cards.map(
                        (card) =>
                        (
                            <MobileUtilisationCard
                                key={card.id}

                                title={card.title}
                                icon={card.icon}
                                color={card.color}

                                worksettings={
                                    card.worksettings
                                }

                                observations={
                                    card.observations
                                }

                                average={
                                    card.average
                                }

                                peak={
                                    card.peak
                                }

                                clickFunction={
                                    card.clickFunction
                                }
                            />
                        )
                    )
                }

            </div>

        </div>
		<MobileUtilisationNavigator
		    selected="summary"
		/>
		</div>
    );

}